import { createReducer } from '@reduxjs/toolkit';
import { EMBEDDED } from 'reactApp/appHelpers/configHelpers';

import type { EmbeddedState } from './embedded.types';

const initialState: EmbeddedState = EMBEDDED || { item: null };

export const embeddedReducer = createReducer(initialState, {});
